import { useEffect, useState } from 'react'

// Re-renders on an interval so "in 2h" / "Now · 22m left" / "Done" stay current.
export function useNow(intervalMs = 30_000) {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs)
    return () => clearInterval(id)
  }, [intervalMs])
  return now
}
